module.exports = __webpack_public_path__ + "static/media/car-garage.4d339502.svg";